<p-card [style]="{ width: '75vw' }">
  <div class="flex w-full">
    <div *ngIf="pageVars.isReady" class="flex" style="width: 22.5rem">
      <p-table
        #dt
        [value]="catalogInsects"
        dataKey="id"
        [scrollable]="true"
        scrollHeight="60vh"
        selectionMode="single"
        [globalFilterFields]="['insect.scientificName']"
        [(selection)]="selectedCatalogInsect">
        <ng-template #caption>
          <p-iconfield iconPosition="left" class="ml-auto">
            <p-inputicon>
              <i class="pi pi-search"></i>
            </p-inputicon>
            <input #searchBox pInputText type="text" (input)="dt.filterGlobal(searchBox.value, 'contains')" placeholder="Search keyword" />
          </p-iconfield>
        </ng-template>
        <ng-template #body let-item>
          <tr [pSelectableRow]="item">
            <div
              style="
                margin: 0.25rem;
                border: 1px solid lightgray;
                padding: 1rem;
                border-radius: 0.5rem;
                box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.15);
              ">
              <div style="font-size: large; font-weight: bolder">{{ item.insect.scientificName }}</div>
              <div *ngIf="item.isActive == false" class="flex w-full text-red-500 text-xs">Inactive</div>

              <div class="flex flex-wrap" style="font-size: x-small; margin-top: 0.25rem">
                <div class="flex-item" *ngFor="let gs of item.growthStages">
                  <p-tag
                    *ngIf="gs.isActive && gs.isAvailable"
                    severity="secondary"
                    [style]="{ 'font-size': 'x-small', 'font-weight': '600', 'margin': '0.1rem', 'line-height': '0.75rem' }">
                    {{ gs.insectGrowthStage.growthStage.name }}
                  </p-tag>
                </div>
              </div>
              <hr style="color: lightgray; width: 75%" />
              <div class="flex flex-wrap" style="font-size: x-small; margin-top: 0.25rem">
                <div class="flex-item" *ngFor="let v of item.variants">
                  <p-tag
                    *ngIf="v.isActive && v.isAvailable"
                    severity="secondary"
                    [style]="{ 'font-size': 'x-small', 'font-weight': '600', 'margin': '0.1rem', 'line-height': '.75rem' }">
                    {{ v.insectVariant.variantType.name }}
                  </p-tag>
                </div>
              </div>
            </div>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div *ngIf="pageVars.isReady" class="flex ml-4" style="width: 70rem">
      <p-fieldset legend="{{ selectedCatalogInsect.insect.scientificName }}" *ngIf="selectedCatalogInsect" class="flex-column w-full">
        <div class="mb-4 pb-3 border-bottom-1 surface-border">
          <div class="flex align-items-center gap-3">
            <p-floatlabel variant="on" class="w-full">
              <p-select
                id="preferredCommonName"
                [(ngModel)]="selectedCatalogInsect.insectSynonymId"
                [options]="getActiveInsectSynonyms()"
                optionLabel="name"
                optionValue="id"
                [style]="{ width: '20rem' }"
                [showClear]="true"
                [disabled]="selectedCatalogInsect.isActive === false"
                (onChange)="updatePreferredCommonName()"
                appendTo="body"
                attr.data-testid="preferredCommonName{{ selectedCatalogInsect.id }}">
                <ng-template let-option pTemplate="item">
                  <div>{{ option.name }}</div>
                </ng-template>
              </p-select>
              <label for="on_label">Preferred Common Name</label>
            </p-floatlabel>
          </div>
        </div>
        <div>
          <p-table [value]="selectedCatalogInsect.growthStages">
            <ng-template #caption>
              <span style="font-size: small; font-weight: bolder">Growth Stages</span>
            </ng-template>
            <ng-template #header>
              <tr style="font-size: small">
                <th>Name</th>
                <th>Available</th>
                <th>Lead Time</th>
                <th>Vendor</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template #body let-item>
              <tr>
                <td style="width: 15rem">
                  <div class="flex w-full">{{ item.insectGrowthStage.growthStage.name }}</div>
                  <div *ngIf="item.isActive == false" class="flex w-full text-red-500 text-xs">Inactive</div>
                </td>
                <td>
                  <p-toggleswitch
                    [(ngModel)]="item.isAvailable"
                    [disabled]="item.isActive === false || selectedCatalogInsect.isActive === false"
                    (change)="updateInsectGrowthStage(item)"
                    attr.data-testid="isAvailable{{ item.id }}" />
                </td>

                <td>
                  <p-inputnumber
                    id="leadTime"
                    name="leadTime"
                    [(ngModel)]="item.leadTime"
                    inputId="leadTime"
                    mode="decimal"
                    size="small"
                    [min]="0"
                    [max]="365"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="0"
                    [useGrouping]="false"
                    (onInput)="updateInsectGrowthStage(item)"
                    attr.data-testid="leadTime{{ item.id }}"
                    [disabled]="item.isActive === false || item.isAvailable === false || selectedCatalogInsect.isActive === false" />
                </td>
                <td>
                  <p-toggleswitch
                    [(ngModel)]="item.isExternal"
                    [disabled]="item.isActive === false || item.isAvailable === false || selectedCatalogInsect.isActive === false"
                    (change)="updateInsectGrowthStage(item)"
                    attr.data-testid="isAvailable{{ item.id }}" />
                </td>
                <td style="width: 15rem">
                  <app-audit-info [value]="item" [direction]="'vertical'"></app-audit-info>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <p-table [value]="selectedCatalogInsect.variants">
            <ng-template #caption>
              <span style="font-size: small; font-weight: bolder">Variants</span>
            </ng-template>
            <ng-template #header>
              <tr style="font-size: small">
                <th>Name</th>
                <th>Available</th>
                <th>Site Code</th>
                <th>Lead Time</th>
                <th>Vendor</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template #body let-item>
              <tr>
                <td style="width: 15rem">
                  <div>{{ item.insectVariant.variantType.name }}</div>
                  <div *ngIf="(item.insectVariant?.description?.length ?? 0) > 0" style="font-size: x-small">
                    {{ item.insectVariant.description }}
                  </div>
                  <div *ngIf="item.isActive == false" class="flex w-full text-red-500 text-xs">Inactive</div>
                </td>
                <td>
                  <p-toggleswitch
                    [(ngModel)]="item.isAvailable"
                    [disabled]="item.isActive === false || selectedCatalogInsect.isActive === false"
                    (change)="updateInsectVariant(item)"
                    attr.data-testid="isAvailable{{ item.id }}" />
                </td>
                <td>
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="item.siteCode"
                    (ngModelChange)="updateInsectVariant(item)"
                    maxlength="256"
                    placeholder="Site Code"
                    [disabled]="item.isActive === false || item.isAvailable === false || selectedCatalogInsect.isActive === false"
                    [style]="{ width: '6rem' }"
                    attr.data-testid="siteCode{{ item.id }}" />
                </td>
                <td>
                  <p-inputnumber
                    id="leadTime"
                    name="leadTime"
                    [(ngModel)]="item.leadTime"
                    inputId="leadTime"
                    mode="decimal"
                    size="small"
                    [min]="0"
                    [max]="365"
                    [showClear]="true"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="0"
                    [useGrouping]="false"
                    (onInput)="updateInsectVariant(item)"
                    attr.data-testid="leadTime{{ item.id }}"
                    [disabled]="item.isActive === false || item.isAvailable === false || selectedCatalogInsect.isActive === false" />
                </td>
                <td>
                  <p-toggleswitch
                    [(ngModel)]="item.isExternal"
                    [disabled]="item.isActive === false || item.isAvailable === false || selectedCatalogInsect.isActive === false"
                    (change)="updateInsectVariant(item)"
                    attr.data-testid="isAvailable{{ item.id }}" />
                </td>
                <td style="width: 15rem">
                  <app-audit-info [value]="item" [direction]="'vertical'"></app-audit-info>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-fieldset>
    </div>
  </div>
</p-card>
